import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslationService} from '../../form-translate/services/transation.service.service';
import { DropdownConfiguration } from 'dhwani-material-library';

@Component({
  selector: 'app-download-data-dialog',
  templateUrl: './download-data-dialog.component.html',
  styleUrls: ['./download-data-dialog.component.css']
})
export class DownloadDataDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<DownloadDataDialogComponent>,
  public translationService: TranslationService) { }

  layoutOptions = [{value: "unpublished", label: "Unpublished"}];
  selectedData = "unpublished";
  languages: any = [];
  selectedLanguage: string = "en";
  dropdownConfig: DropdownConfiguration<any> = {
    label: 'Select Language',
    keyUsedForSearch: 'name',
    type: 'single',
    parentKeyToDisplay: 'name',
    valueToEmit: 'code'
};

  ngOnInit() {
    if(this.data.form.publishedFormId)
    this.layoutOptions.push({value: "published", label: "Published"});
    this.getLanguages();
  }

  downloadData(){
    let options = {
      formType: this.selectedData,
      language: this.selectedLanguage
  }
    this.dialogRef.close(options);
  }

  onSelectionChange(event) {
    this.selectedLanguage = event.value;
  }

  getLanguages() {
    let formId = this.data.form._id;
    this.translationService.getLanguages(formId).then((response: any) => {
      if (response.success) {
        let formLanguages = response.formLanguages;
        this.languages = response.data.filter(item => formLanguages.includes(item.code));
        this.setPreselected();
      }
    });

  }

setPreselected() {
  let preSelected = this.languages.findIndex(item => item.code == this.selectedLanguage)
  this.dropdownConfig = {...this.dropdownConfig, preSelected: preSelected};
}

}
